export const projetos = {
  titulo: 'Projects',
  descricao: 'Projects registered in Axiis.',
  avisoEdicao: 'To edit the project in full, edit it in Axiis BR or Axiis US.',
  total_one: 'Showing {{showing}} of {{count}} project',
  total_other: 'Showing {{showing}} of {{count}} projects',
  colunas: {
    codigo: 'Axis code',
    nome: 'Name',
    unidade: 'Unit',
    cliente: 'Client',
    contrato: 'Contract',
    situacao: 'Status',
    inicio: 'Start',
    termino: 'End',
    gerenteProjeto: 'Project manager',
    gerenteOperacao: 'Operations manager',
    diretorConta: 'Account director',
    interno: 'Internal',
    pool: 'Pool',
  },
  situacoes: {
    emAndamento: 'In progress',
    emContratacao: 'In contracting',
    cancelado: 'Cancelled',
    encerrado: 'Ended',
    emGarantia: 'In warranty',
    desconhecida: 'Unknown status',
  },
  filtros: {
    avancadosDescricao: 'Filter by unit, Axis code, name, contract, internal or pool.',
    todos: 'All',
  },
  tabela: {
    vazioTitulo: 'No projects to show',
    vazioDescricao: 'There are no projects in your scope.',
    filtroSemResultadoTitulo: 'No projects match these filters',
    filtroSemResultadoDescricao: 'Adjust or clear the filters to see the projects.',
  },
  edicao: {
    titulo: 'Edit project',
    aviso:
      'Only the Project manager, Operations manager, Account director, Internal and Pool fields are editable here. To edit the project in full, use Axiis BR or Axiis US.',
    id: 'Id',
    selecionar: 'Select',
    acoes: 'Actions',
    editarProjeto: 'Edit project {{nome}}',
    toastSucesso: 'Project updated.',
    toastErro: 'Could not save the project.',
  },
  exportacao: {
    nomeArquivo: 'projects',
    botao: 'Export',
    titulo: 'Export projects',
    descricao: 'The file follows the applied filters and the columns visible on screen.',
    escopo: 'What to export',
    paginaAtual_one: 'This page only ({{count}} project)',
    paginaAtual_other: 'This page only ({{count}} projects)',
    todos_one: 'All projects ({{count}} project)',
    todos_other: 'All projects ({{count}} projects)',
    todosFiltrados_one: 'All results of the filters ({{count}} project)',
    todosFiltrados_other: 'All results of the filters ({{count}} projects)',
    unicaPagina_one: '{{count}} project will be exported.',
    unicaPagina_other: '{{count}} projects will be exported.',
    formato: 'Format',
  },
} as const;
